export const VIEW_PRODUCT_NEWS = 'VIEW_PRODUCT_NEWS';
export const CHANGE_TITLE_PAGE = 'CHANGE_TITLE_PAGE';


